export const dailyDayForecastTileTestIDs = {
  dayNameText: 'daily_weather_forecast_day_tile_day_name',
  dateText: 'daily_weather_forecast_day_tile_date_text',
  icon: 'daily_weather_forecast_day_tile_icon',
  dayTempText: 'daily_weather_forecast_day_tile_day_temp_text',
  nightTempText: 'daily_weather_forecast_day_tile_night_temp_text',
  precipLabel: 'daily_weather_forecast_day_tile_precip_label',
  precipText: 'daily_weather_forecast_day_tile_precip_text',
  viewHourlyText: 'daily_weather_forecast_day_tile_view_hourly',
};
